// extracted by mini-css-extract-plugin
export default {"menu-item":"activity_menu-item__+Np-M","menu-item__active":"activity_menu-item__active__RWBMU"};